function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import $ from 'dom7';
import Utils from '../../../utils/utils';
export default {
  render: function render(self) {
    var _self$params = self.params,
        sliderLabel = _self$params.sliderLabel,
        sliderValue = _self$params.sliderValue,
        sliderValueEditable = _self$params.sliderValueEditable,
        hueLabelText = _self$params.hueLabelText,
        saturationLabelText = _self$params.saturationLabelText,
        brightnessLabelText = _self$params.brightnessLabelText;
    return "\n      <div class=\"color-picker-module color-picker-module-hsb-sliders\">\n        <div class=\"color-picker-slider-wrap\">\n          ".concat(sliderLabel ? "\n            <div class=\"color-picker-slider-label\">".concat(hueLabelText, "</div>\n          ") : '', "\n          <div class=\"range-slider color-picker-slider color-picker-slider-hue\"></div>\n          ").concat(sliderValue ? "\n            <div class=\"color-picker-slider-value\">\n              ".concat(sliderValueEditable ? "\n                <input type=\"number\" step=\"0.1\" min=\"0\" max=\"360\" class=\"color-picker-value-hue\" data-color-index=\"0\">\n              " : "\n                <span class=\"color-picker-value-hue\"></span>\n              ", "\n            </div>\n          ") : '', "\n        </div>\n        <div class=\"color-picker-slider-wrap\">\n          ").concat(sliderLabel ? "\n            <div class=\"color-picker-slider-label\">".concat(saturationLabelText, "</div>\n          ") : '', "\n          <div class=\"range-slider color-picker-slider color-picker-slider-saturation\"></div>\n          ").concat(sliderValue ? "\n            <div class=\"color-picker-slider-value\">\n              ".concat(sliderValueEditable ? "\n                <input type=\"number\" step=\"0.1\" min=\"0\" max=\"100\" class=\"color-picker-value-saturation\" data-color-index=\"1\">\n              " : "\n                <span class=\"color-picker-value-saturation\"></span>\n              ", "\n            </div>\n          ") : '', "\n        </div>\n        <div class=\"color-picker-slider-wrap\">\n          ").concat(sliderLabel ? "\n            <div class=\"color-picker-slider-label\">".concat(brightnessLabelText, "</div>\n          ") : '', "\n          <div class=\"range-slider color-picker-slider color-picker-slider-brightness\"></div>\n          ").concat(sliderValue ? "\n            <div class=\"color-picker-slider-value\">\n              ".concat(sliderValueEditable ? "\n                <input type=\"number\" step=\"0.1\" min=\"0\" max=\"100\" class=\"color-picker-value-brightness\" data-color-index=\"2\">\n              " : "\n                <span class=\"color-picker-value-brightness\"></span>\n              ", "\n            </div>\n          ") : '', "\n        </div>\n      </div>\n    ");
  },
  init: function init(self) {
    self.hueRangeSlider = self.app.range.create({
      el: self.$el.find('.color-picker-slider-hue'),
      min: 0,
      max: 360,
      step: 0.1,
      value: 0,
      on: {
        change: function change(range, value) {
          self.setValue({
            hue: value
          });
        }
      }
    });
    self.saturationRangeSlider = self.app.range.create({
      el: self.$el.find('.color-picker-slider-saturation'),
      min: 0,
      max: 1,
      step: 0.001,
      value: 0,
      on: {
        change: function change(range, value) {
          var s = Math.floor(value * 1000) / 1000;
          self.setValue({
            hsb: [self.value.hsb[0], s, self.value.hsb[2]]
          });
        }
      }
    });
    self.brightnessRangeSlider = self.app.range.create({
      el: self.$el.find('.color-picker-slider-brightness'),
      min: 0,
      max: 1,
      step: 0.001,
      value: 0,
      on: {
        change: function change(range, value) {
          var b = Math.floor(value * 1000) / 1000;
          self.setValue({
            hsb: [self.value.hsb[0], self.value.hsb[1], b]
          });
        }
      }
    });

    function handleInputChange(e) {
      var hsb = _toConsumableArray(self.value.hsb);

      var index = parseInt($(e.target).attr('data-color-index'), 10);
      var value = parseFloat(e.target.value);

      if (Number.isNaN(value)) {
        e.target.value = hsb[index];
        return;
      }

      if (index === 0) {
        value = Math.max(0, Math.min(360, value));
      } else {
        value = Math.max(0, Math.min(100, value)) / 100;
      }

      hsb[index] = value;
      self.setValue({
        hsb: hsb
      });
    }

    self.$el.on('change', '.color-picker-module-hsb-sliders input', handleInputChange);

    self.destroyHsbSlidersEvents = function destroyHsbSlidersEvents() {
      self.$el.off('change', '.color-picker-module-hsb-sliders input', handleInputChange);
    };
  },
  update: function update(self) {
    var app = self.app,
        value = self.value;
    var _self$params2 = self.params,
        sliderValue = _self$params2.sliderValue,
        sliderValueEditable = _self$params2.sliderValueEditable;
    var hsb = value.hsb,
        hue = value.hue;
    self.hueRangeSlider.value = hue;
    self.saturationRangeSlider.value = hsb[1];
    self.brightnessRangeSlider.value = hsb[2];
    self.hueRangeSlider.layout();
    self.saturationRangeSlider.layout();
    self.brightnessRangeSlider.layout();
    var hslCurrent = Utils.colorHsbToHsl(hsb[0], hsb[1], 1);
    var hslLeft = Utils.colorHsbToHsl(hsb[0], 0, 1);
    var hslRight = Utils.colorHsbToHsl(hsb[0], 1, 1);
    var brightness = hsb[2];
    self.hueRangeSlider.$el[0].style.setProperty('--f7-range-knob-color', "hsl(".concat(hue, ", 100%, 50%)"));
    self.saturationRangeSlider.$el[0].style.setProperty('--f7-range-knob-color', "hsl(".concat(hslCurrent[0], ", ").concat(hslCurrent[1] * 100, "%, ").concat(hslCurrent[2] * 100, "%)"));
    self.brightnessRangeSlider.$el[0].style.setProperty('--f7-range-knob-color', "rgb(".concat(brightness * 255, ", ").concat(brightness * 255, ", ").concat(brightness * 255, ")"));
    self.saturationRangeSlider.$el.find('.range-bar').css('background-image', "linear-gradient(".concat(app.rtl ? 'to left' : 'to right', ", hsl(").concat(hslLeft[0], ", ").concat(hslLeft[1] * 100, "%, ").concat(hslLeft[2] * 100, "%), hsl(").concat(hslRight[0], ", ").concat(hslRight[1] * 100, "%, ").concat(hslRight[2] * 100, "%))"));

    if (sliderValue && sliderValueEditable) {
      self.$el.find('input.color-picker-value-hue').val("".concat(hue));
      self.$el.find('input.color-picker-value-saturation').val("".concat(hsb[1] * 1000 / 10));
      self.$el.find('input.color-picker-value-brightness').val("".concat(hsb[2] * 1000 / 10));
    } else if (sliderValue) {
      self.$el.find('span.color-picker-value-hue').text("".concat(hue));
      self.$el.find('span.color-picker-value-saturation').text("".concat(hsb[1] * 1000 / 10));
      self.$el.find('span.color-picker-value-brightness').text("".concat(hsb[2] * 1000 / 10));
    }
  },
  destroy: function destroy(self) {
    if (self.hueRangeSlider && self.hueRangeSlider.destroy) {
      self.hueRangeSlider.destroy();
    }

    if (self.saturationRangeSlider && self.saturationRangeSlider.destroy) {
      self.saturationRangeSlider.destroy();
    }

    if (self.brightnessRangeSlider && self.brightnessRangeSlider.destroy) {
      self.brightnessRangeSlider.destroy();
    }

    delete self.hueRangeSlider;
    delete self.saturationRangeSlider;
    delete self.brightnessRangeSlider;
    if (self.destroyHsbSlidersEvents) self.destroyHsbSlidersEvents();
    delete self.destroyHsbSlidersEvents;
  }
};